export default {"src":"/_next/static/media/home-hashtag.0c7c5086.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};